(() => {
  const elements = {
    imageWrapper: document.querySelector('.product-single__media-container'),
    productMedia: document.querySelector('.product-single__media-container .product-single__media'),
    sentinelPixel: document.querySelector('.product-single__media-container .sentinel-pixel'),
    announcement: document.querySelector('#shopify-section-announcement-bar'),
    header: document.querySelector('#shopify-section-header')
  }

  function attachStickyMediaClass() {
    if(!elements.imageWrapper) return;
    // console.log("attachStickyMediaClass()", elements.imageWrapper);
    elements.imageWrapper.classList.add('sticky-media');
    adjustMediaTop();
  }

  function adjustMediaTop() {
    if(!elements.productMedia) return;
    // console.log("adjustMediaTop()", elements.productMedia);
    let newTop = 'unset';
    if (window.innerWidth > 768) {
      // elementDetails();
      const sentinelPosition = elements.sentinelPixel.getBoundingClientRect().top + window.scrollY;
      if(window.innerHeight > sentinelPosition){
        // console.log("the sentinel pixel was intersecting the viewport on load.");
        newTop = `${sentinelPosition - elements.productMedia.offsetHeight - elements.announcement.offsetHeight}px`;
      } else {
        // console.log("the sentinel pixel was not intersecting the viewport on load.");
        newTop = `${sentinelPosition - elements.productMedia.offsetHeight - elements.header.offsetHeight}px`;
      }
    }
    // console.log(`newTop: ${newTop}`);
    elements.productMedia.style.top = newTop;
  }

  function initSentinelObserver() {
    if(!elements.sentinelPixel) return;
    // console.log("initSentinelObserver()", elements.sentinelPixel);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(!entry.isIntersecting && window.scrollY < elements.announcement.offsetHeight) return;
        if(entry.isIntersecting && entry.target === elements.sentinelPixel) {
          // console.log(`We are now intersecting the sentinel pixel`);
          if(elements.productMedia){
            attachStickyMediaClass();
            observer.disconnect();
          }
        }
      });
    }, {
      threshold: 1
    });

    observer.observe(elements.sentinelPixel);
  }

  function elementDetails(){
    console.log(`window.scrollY: ${window.scrollY}px`);
    console.log(`window.innerHeight: ${window.innerHeight}px`);
    console.log(`elements.announcement.offsetHeight: ${elements.announcement.offsetHeight}px`);
    console.log(`elements.header.offsetHeight: ${elements.header.offsetHeight}px`);
    console.log(`elements.productMedia.offsetHeight: ${elements.productMedia.offsetHeight}px`);
    console.log(`elements.sentinelPixel.getBoundingClientRect().top: ${elements.sentinelPixel.getBoundingClientRect().top}px`);
    console.log(`sentinelPosition: ${elements.sentinelPixel.getBoundingClientRect().top + window.scrollY}px`);
  }

  document.addEventListener("DOMContentLoaded",() => {
    // elementDetails();
    const sentinelPosition = elements.sentinelPixel.getBoundingClientRect().top + window.scrollY;
    if(window.innerHeight > sentinelPosition){
      // console.log("the sentinel pixel is intersecting the viewport on load.");
    } else {
      // console.log("the sentinel pixel is not intersecting the viewport on load.");
    }
    initSentinelObserver();
  });
})();
